export const InvoiceBatchStatus = {
  PENDING: "Pending",
  UPLOADED: "Uploaded",
  SUBMITTED: "Submitted",
  APPROVED: "Approved",
  PAID: "Paid",
};
